/**
 * SkillDelivery Platform
 *
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * Single source of truth for the four featured SkillDelivery domains.
 * Consumed by WelcomeRouter (button row) and DomainLanding (slug lookup).
 */

export const DOMAINS = [
  { slug: 'wms',      name: 'Warehouse Management (WMS)', shortLabel: 'WMS',     icon: '📦', featured: true  },
  { slug: 'iseries',  name: 'IBM iSeries / AS400',         shortLabel: 'iSeries', icon: '💻', featured: false },
  { slug: 'civil',    name: 'Civil Construction',          shortLabel: 'Civil',   icon: '🏗️', featured: false },
  { slug: 'apparel',  name: 'Apparel & Stitching',         shortLabel: 'Apparel', icon: '✂️', featured: false },
  {
    slug: 'erpnext',
    name: 'ERPNext',
    shortLabel: 'ERPNext',
    icon: '⚡',
    featured: false,
    yearsLabel: 'PoC Ready',
    description: 'Open-source ERP for Indian MSMEs — distribution, manufacturing, civil contracting'
  }
];

export const getDomainBySlug = (slug) =>
  DOMAINS.find(d => d.slug === String(slug || '').toLowerCase());
